
import { indexDBStore } from '@/store/index'
import IndexDB from '@/utils/indexDB'

export async function createDB(readyCb: () => void) {
  // 获取IndexDB的store
  const useIndexDBStore = indexDBStore()
  try {
    const indexDB = new IndexDB('cache', 1)
    await indexDB.openDB([
      {
        storeName: 'cacheMicro',
        optionalParameters: { keyPath: 'id', autoIncrement: true },
        storeIndexList: [
          {
            name: 'cacheMicroAppList',
            params: {
              unique: false
            }
          }
        ]
      },
      {
        storeName: 'cacheMicroNum',
        optionalParameters: { keyPath: 'id', autoIncrement: true }
      }
    ])
    useIndexDBStore.setIndexDB(indexDB)
  } catch (_) {
    console.log('数据库连接失败', _)
  } finally {
    readyCb()
  }
}

export async function dekleteDB() {
  IndexDB.deleteDB('cache')
}
